import { helpers } from 'vuelidate/lib/validators'
const oneOf = (array) => helpers.withParams(
    {type: 'oneOf', array},
    (value) => {
        return !helpers.req(value) || array.includes(value)
    }
)
export default oneOf;